import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AuthState, AuthStateModel} from '../states/auth/auth.state';
import {Store} from '@ngxs/store';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard  {

  constructor(
    private store: Store,
    private router: Router,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const authState: AuthStateModel = this.store.selectSnapshot(AuthState);        
    if (authState.accessToken) {      
      if (authState.pharmacyId || authState.pharmacies === undefined) {        
        return true;
      }      
      
      if (!authState.pharmacies.length) {
        if (!state.url.includes('/auth/') && state.url !== '/dashboard/set-up') {
          this.router.navigateByUrl('/dashboard/set-up');
        }
        return true;
      } else if(!authState.userHasPinResponse) {
        if (!state.url.includes('/auth/') && state.url !== '/dashboard/set-up') {
          this.router.navigateByUrl('/dashboard/set-up');
        }
      }
      return true;
    } else {
      this.router.navigateByUrl('/auth/login');
    }
    return false;
  }
}
